module.exports = __webpack_public_path__ + "img/figures-4.1.e9c13448.png";